import React, { FC } from 'react';

import { HarvestSummaryTabProps } from './HarvestSummary.props';

import HarvestSummaryTabContent from './HarvestSummaryTabContent';
import { InventoryReportStatusEnum } from 'types/report';
const ReadyForImpactSummary: FC<HarvestSummaryTabProps> = (props) => {
  const { counts, ...data } = props;
  const filteredCounts = counts.filter(
    (count) => count.status === InventoryReportStatusEnum.READY_FOR_IMPACT,
  );

  return <HarvestSummaryTabContent counts={filteredCounts} {...data} />;
};

export default ReadyForImpactSummary;
